import ApiService from '../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            pages: [],
            partners: [],
            responsibles: [],
            masters: [],
            cemeteries: [],
        }
    },
    getters: {
        responsibles: (state) => {
            return state.responsibles;
        },
        partners: (state) => {
            return state.partners;
        },
        masters: (state) => {
            return state.masters;
        },
        cemeteries: (state) => {
            return state.cemeteries;
        }
    },
    mutations: {
        setPages(state, value) {
            state.pages = value;
        },
        setResponsibles(state, value) {
            state.responsibles = value;
        },
        addPage(state, value) {
            state.pages.data.push(value);
        },
        removePage(state, item) {
            for (let i = 0; i < state.pages.data.length; i++) {
                if (state.pages.data[i].id === item.id) {
                    window.Vue.delete(state.pages.data, i, item);
                }
            }
        },
        removePages(state, items) {
            let resultPages = [];

            for (let i = 0; i < state.pages.data.length; i++) {
                let isDelete = false;

                items.forEach((item) => {
                    if (state.pages.data[i].id === item.id) {
                        isDelete = true;
                    }
                });

                if (!isDelete) {
                    resultPages.push(state.pages.data[i]);
                }
            }

            window.Vue.set(state.pages, 'data', resultPages);
        },
        updatePage(state, item) {
            for (let i = 0; i < state.pages.data.length; i++) {
                if (state.pages.data[i].id === item.id) {
                    window.Vue.set(state.pages.data, i, item);
                }
            }
        },
    },
    actions: {
        index({state, commit, getters}, payload = {}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/admin-page', payload)
                    .then((response) => {
                        commit('setPages', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        deletePage({state, commit, getters}, id){
            return new Promise((resolve, reject) => {
                ApiService.delete('/page/'+ id)
                    .then((response) => {
                        commit('removePage',response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        restorePage({state, commit, getters}, id){
            return new Promise((resolve, reject) => {
                ApiService.get('/page/'+ id + '/restore')
                    .then((response) => {
                        commit('removePage',response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        getPartnersList({state, commit, getters}) {
            ApiService.get('/partners-list')
                .then((response) => {
                    state.partners = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getResponsiblesList({state, commit, getters}, responsibleParams) {
            return new Promise((resolve, reject) => {
                ApiService.post('/responsibles-list', responsibleParams)
                    .then((response) => {
                        state.responsibles = response.data;
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        responsibleSearch({state, commit, getters}, responsibleParams) {
            return new Promise((resolve, reject) => {
                ApiService.post('/search-responsible',  responsibleParams)
                    .then((response) => {
                        state.responsibles = response.data;
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        masterSearch({state, commit, getters}, masterParams) {
            return new Promise((resolve, reject) => {
                ApiService.post('/search-master', masterParams)
                    .then((response) => {
                        state.masters = response.data;
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        partnerSearch({state, commit, getters}, partnerParams) {
            return new Promise((resolve, reject) => {
                ApiService.post('/search-partner', partnerParams)
                    .then((response) => {
                        state.partners = response.data;
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        cemeterySearch({state, commit, getters}, cemeteryParams) {
            return new Promise((resolve, reject) => {
                ApiService.post('/search-cemetery', cemeteryParams)
                    .then((response) => {
                        state.cemeteries = response.data;
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        getMastersList({state, commit, getters}, id = 0) {
            return new Promise((resolve, reject) => {
                ApiService.get('/masters-list/' + id)
                    .then((response) => {
                        state.masters = response.data;
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        getAllResponsibles({state, commit, getters}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/all-responsibles')
                    .then((response) => {
                        resolve(response);
                        state.responsibles = response.data;
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        getAllMasters({state, commit, getters}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/all-masters')
                    .then((response) => {
                        resolve(response);
                        state.masters = response.data;
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        getAllToros({state, commit, getters}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/all-toros')
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        getAllCemeteries({state, commit, getters}, params) {
            return new Promise((resolve, reject) => {
                ApiService.get('/all-cemeteries', params)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        getImageVideo({state, commit, getters}, url) {
            return new Promise((resolve, reject) => {
                ApiService.post('/page/get-image-video', {url: url})
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        downloadYouTubeVideo({state, commit, getters}, data) {
            return new Promise((resolve, reject) => {
                ApiService.post('/media/download-youtube-video', data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        convertPageToBurial({state, commit, getters}, slug) {
            return new Promise((resolve, reject) => {
                ApiService.post('/page/convert-to-burial', {page_slug: slug})
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        convertBurialPageToPage({state, commit, getters}, slug) {
            return new Promise((resolve, reject) => {
                ApiService.post('/page/convert-burial-page-to-page', {page_slug: slug})
                    .then((response) => {
                        resolve(response);
                    }).catch((error) => {
                        reject(error);
                    });
            });
        },
        forceDelete({state, commit}, pages) {
            ApiService.post('/page/force-delete', {pages: pages})
                .then((response) => {
                    commit('removePages', response.data);
                }).catch((error) => {
                console.log(error);
            });
        },
        addCopyright({state, commit}, id) {
            return new Promise((resolve, reject) => {
                ApiService.get(`/service/${id}/add-copyright`)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        addTable({state, commit}, id) {
            return new Promise((resolve, reject) => {
                ApiService.get(`/service/${id}/add-table`)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        deleteCopyright({state, commit}, id) {
            return new Promise((resolve, reject) => {
                ApiService.get(`/service/${id}/delete-copyright`)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        deleteTable({state, commit}, id) {
            return new Promise((resolve, reject) => {
                ApiService.get(`/service/${id}/delete-table`)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        bindSlug({state, commit}, slugs) {
            return new Promise((resolve, reject) => {
                ApiService.post('/page/bind-slug', slugs)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        updatePageCounters({state, commit, getters}, id) {
            return new Promise((resolve, reject) => {
                ApiService.post('/page/update-counters/' + id)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        addToBurial({state, commit}, data) {
            return new Promise((resolve, reject) => {
                ApiService.post('/page/add-to-burial', data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        removeFromBurial({state, commit}, data) {
            return new Promise((resolve, reject) => {
                ApiService.post('/page/remove-from-burial', data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        updatePageLocale({state, commit}, data) {
            return new Promise((resolve, reject) => {
                ApiService.post('/page/update-page-locale', data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        updatePageHistoricalStatus({state, commit}, data) {
            return new Promise((resolve, reject) => {
                ApiService.post('/page/update-page-history-status', data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        }
    }
};
